import { observer } from "mobx-react-lite";
import React, { useId } from "react";
export const IdProvider = observer((props) => {
    const id = useId();
    return React.createElement(React.Fragment, null, props.children(id));
});
//# sourceMappingURL=IdProvider.js.map